module.exports = __webpack_public_path__ + "media/promo/panasonic/images/buy-2-128bde7bcbccfd51077af736f10a5c4c.png";